import React, {useEffect, useState} from 'react';

const EntryList = (props) => {
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (props.onSubmit) {
      let isValid = false;
      if (props.selectedEntry) {
        isValid = true;
      }
      setShowError(!isValid);
      props.onValid({valid: isValid});
    }
  }, [props.onSubmit]);

  useEffect(() => {
    if (props.selectedEntry) {
      setShowError(false);
    }
  }, [props.selectedEntry]);

  return (
    <>
      <div className='entry-list'>
        {props.entries.map((item, index) => (
          <div
            key={index}
            onClick={() => {
              props.setSelectedEntry(item);
            }}
            className={`entry ${item.entry == props.selectedEntry?.entry ? 'active' : ''}`}>
            {index === props.entries.length - 1 ? `כניסה ${item.entry}` : `כניסה ${item.entry}'`}
          </div>
        ))}
      </div>
      {showError && <p className='error'>אנא בחר כניסה</p>}
    </>
  );
};

export default EntryList;
